<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load">
          <lg-form-const-select label="Situação:" cols="3" sm="2" md="2" v-model="form.situacao"
            :options="form.optionsFilterSituacao" @change="load" />

          <lg-form-input v-model="form.descricao" label="Descrição:" cols="6" sm="6" />

          <b-col lg="1" sm="1" class="ml-4 d-flex justify-content-end align-items-center">
            <b-button id="limparDocumento" class="my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="limpar">
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              <b-tooltip target="limparDocumento" title="Limpar"></b-tooltip>
            </b-button>

            <b-button id="localizarTipoDocumento" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
              variant="primary" @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizarTipoDocumento" title="Localizar"></b-tooltip>
            </b-button>
          </b-col>

          <b-col lg="2" sm="2" class="text-right d-flex justify-content-end align-items-center">
            <b-button id="novoTipoDocumento" class="ml-3 mr-2 my-2" style="height: 20px"
              @click="showAlmoxarifadoModal(null)" size="sm" pill variant="secondary">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="novoTipoDocumento" title="Adicionar novo..."></b-tooltip>
            </b-button>
          </b-col>


        </b-form-row>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" show-empty
          @row-dblclicked="onDblClickSelect"
          
          >


          <template #empty>
            <p>
              Nenhum Registro encontrado
            </p>
          </template>


          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>


          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'switchGrupo'">
              <b-form-checkbox v-model="row.item.situacao" @change="alteraSituacao(row.item)" name="check-button" switch
                size="lg" :value="1" :unchecked-value="0" />
              <b-tooltip :target="row.index + 'switchGrupo'" title="Ativar/Desativar..."></b-tooltip>
            </div>
          </template>

          <template v-slot:cell(action)="row">
            <b-button :id="row.index + 'edit-button-tipo-documento'" class="my-2" size="sm" pill variant="primary"
              @click="showAlmoxarifadoModal(row.item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="row.index + 'edit-button-tipo-documento'" title="Editar..."></b-tooltip>
            </b-button>
          </template>


        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <TipoDocumentoForm v-if="show" @close="cancelar" :prefix="prefix + title + ' > '" :id="id"></TipoDocumentoForm>
  </b-card>
</template>

<script>
import ConfirmMixin from "@/core/mixins/confirm"

import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import TipoDocumentoForm from "./TipoDocumentoForm.vue";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    TipoDocumentoForm
  },
  props: {
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Tipo de Documento"
    },




  },

  data() {
    return {
      show: false,
      id: null,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      form: {
        descricao: "",
        situacao: 1,
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: null },
          { key: "filterSituacao", text: "Ativo", value: 1 },
          { key: "filterSituacao", text: "Inativo", value: 0 },
        ],
      },
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/tipo-documento`);
  },
  mounted() {
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    tableFields() {
      return [
        { key: "descricao", label: "Descrição" },
        { key: "validade", label: "Validade" },
        { key: "situacao", label: " ", tdClass: "w-1" },
        { key: "action", label: " ", tdClass: "w-1" },
      ];
    },
  },
  methods: {
    onDblClickSelect(item){
      this.$emit("onDblClickSelect", item);
    },
    showAlmoxarifadoModal(item) {
      if (item)
        this.id = item.id;
      this.show = true;
    },
    cancelar() {
      this.id = null;
      this.show = false;
      this.load();
    },
    limpar() {
      this.form.situacao = 1;
      this.form.descricao = "";
      this.load();
    },
    async load() {
      this.filtro = {};
      if (this.form.descricao && this.form.descricao.length > 0) {
        this.filtro.descricao = this.form.descricao;
      }
      if (this.form.situacao != null) {
        this.filtro.situacao = this.form.situacao;
      }

      this.busy = true;
      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      });
    },

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Tipo Documento?",
        item.descricao.toUpperCase()
      )
      if (response == true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
    },


    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        })
      }
    },

  },
};
</script>
